const NAMESPACE = "chplus";
const ProgressStepId = {
  /**
   * Has the user finished creating their account?
   */
  Onboarding: `${NAMESPACE}:onboarding`,
  /**
   * Has the user opened the election home page
   */
  ElectionHome: `${NAMESPACE}:election_home`,
  /**
   * Has the user matched all candidates of their first election?
   */
  Match: `${NAMESPACE}:match`,
  /**
   * Has the user ever chosen a list as their dream team?
   */
  FavoriteList: `${NAMESPACE}:favorite_list`,
  /**
   * Has the user ever answered all level 1 questions for one election?
   */
  Questionnaire: `${NAMESPACE}:questionnaire`,
  /**
   * Has the user ever answered all level 1 & 2 questions for one election?
   */
  QuestionnaireAdvanced: `${NAMESPACE}:questionnaire_advanced`,
  /**
   * Has the user ever confirmed the sorting on their favorites?
   */
  Favorites: `${NAMESPACE}:favorites`,
  /**
   * Has the user ever created a custom list?
   */
  CustomList: `${NAMESPACE}:custom_list`,
  /**
   * Has the user ever confirmed that they have inspected their dream team?
   */
  DreamTeams: `${NAMESPACE}:dream_teams`,
  /**
   * Has the user used the level switch?
   */
  LevelSwitch: `${NAMESPACE}:level_switch`,
  /**
   * Has the user used the level switch a second time?
   */
  LevelSwitchBack: `${NAMESPACE}:level_switch_back`,
  /**
   * Has the user seen the year selector modal?
   */
  YearSelector: `${NAMESPACE}:year_selector`,
  /**
   * Has the user ever confirmed they've seen the results view?
   */
  Results: `${NAMESPACE}:results`,
  /**
   * Has the user seen the tutorial for the favorites view?
   */
  TutorialFavorites: `${NAMESPACE}:tutorial_favorites`,
  /**
   * Has the user seen the tutorial for the home screen?
   */
  TutorialHome: `${NAMESPACE}:tutorial_home`,
  /**
   * Has the user seen the tutorial for the list editor?
   */
  TutorialListEditor: `${NAMESPACE}:tutorial_list_editor`,
  /**
   * Has the user seen the tutorial for the lists view?
   */
  TutorialLists: `${NAMESPACE}:tutorial_lists`,
  /**
   * Has the user seen the tutorial for the match view?
   */
  TutorialMatch: `${NAMESPACE}:tutorial_match`,
  /**
   * Has the user seen the tutorial for the dream teams view?
   */
  TutorialDreamTeams: `${NAMESPACE}:tutorial_dream_teams`,
  /**
   * Has the user seen the tutorial for the dream teams view?
   */
  SeenAll: `${NAMESPACE}:seen_all`
};

export { ProgressStepId };
